<template>
  <div class="area-setting-close-button h-full" @click="onClickClose">
    <close-icon></close-icon>
  </div>
</template>

<script>
import CloseIcon from "./CloseIcon.vue";
const EMIT_EVENTS = {
  CLOSE: "close",
};

export default {
  name: "CloseButton",
  components: {
    CloseIcon,
  },
  methods: {
    onClickClose(event) {
      this.$emit(EMIT_EVENTS.CLOSE, event);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/aisea/_variables.scss";
.area-setting-close-button {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 35px;
  width: 35px;

  border-radius: 24px;
  background: $aisea-mouse-gray;

  cursor: pointer;

  &:hover {
    background: #9c9c9c;
  }

  &:active {
    background: #888888;
  }
}
</style>
